import axios from 'axios'

export default {
  state: {
    //
  },
  actions: {
    getProductPluginLink({commit, dispatch}, state) {
      const message = {
        title: 'Use with your favorite design tools 👨‍💻!',
        text: `Build something awesome and if you enjoy the plugin then don't forget to show some love ❤️!`,
        color: 'grey darken-4',
        value: true,
      }
      dispatch('pluginDialog', message)
    },
    async submitPhoto({commit, dispatch}, payload) {
      try {
        await dispatch('onLoading', true)
        const resp = await axios.post('https://awesome-app-api.herokuapp.com/photos/submit', {
          first_name: payload.firstName,
          last_name: payload.lastName,
          email: payload.email,
          photo_link: payload.photoLink,
        })
        await dispatch('onLoading', false)
        await dispatch('snackbarAction', {
          data: {
            message: resp.data.message,
            color: 'green',
          },
          isActive: true,
        })
      } catch (err) {
        console.log(err)
        await dispatch('onLoading', false)
        await dispatch('snackbarAction', {
          data: {
            message: 'Opps, Something went wrong 😩!',
            color: 'black',
          },
          isActive: true,
        })
      }
    },
  },
  mutations: {
    //
  },
  getters: {
    //
  },
}
